<template>
  <div class="radio-button" :disabled="disabled || null">
    <slot />
    <label :for="id">
      {{ title }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.radio-button {
  :deep() {
    @include custom-radio-checkboxes;
    margin-top: 0.2em;

    display: inline-block;

    &:not(:last-child) {
      margin-right: 1em;
    }

    &[disabled] {
      color: #a3b7c0;
    }
  }
}
input:checked + label::after {
  background: $color-primary;
}

label {
  &::before,
  &::after {
    border-radius: 50%;
  }

  &::after {
    content: '';
    transition: all 0.1s ease-out;
    display: block;
    position: absolute;
    transform: translate(50%, 50%);
    height: 0.5em;
    width: 0.5em;
    left: 0;
    top: 0.25em;
  }
}
</style>
